var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inpatient-information"},[_vm._v("住院人信息")])
}
var staticRenderFns = []

export { render, staticRenderFns }